<script setup lang="ts">
import type { ConfiguratorPool } from '~/models/configurator/configuratorPool.model'

const props = defineProps<{
  currentPool: ConfiguratorPool | null
  formLabel: string
}>()
const emits = defineEmits<{
  openForm: []
}>()

const { t } = useI18n()
const { dt } = useDirectusTranslation()

const selectedConfiguration = computed(() => {
  return [
    {
      label: t('label.pool_line'),
      value: dt(props.currentPool?.poolLine.translations)?.name,
    },
    {
      label: t('label.size'),
      value: props.currentPool?.size?.size,
    },
    {
      label: t('label.stair'),
      value: dt(props.currentPool?.stair.translations)?.name,
    },

    {
      label: t('label.color'),
      value: dt(props.currentPool?.color.translations)?.name,
    },
  ]
})
</script>

<template>
  <div class="w-full flex flex-col items-center justify-center gap-4">
    <p class="textNormal">
      {{ t('label.receive_quote') }}
    </p>
    <div class="w-full flex flex-col gap-4 bg-white/5 p-6">
      <p class="text-xl text-white">
        {{ t('label.your_configuration') }}
      </p>
      <div class="grid grid-cols-2 w-full items-center justify-center gap-x-8 text-left text-lg opacity-60">
        <template v-for="info in selectedConfiguration" :key="info.label">
          <div>
            {{ info.label }}
          </div>
          <div class="font-bold">
            {{ info.value }}
          </div>
        </template>
      </div>
    </div>
    <div class="grid grid-cols-1 w-full gap-4">
      <AppButton variant="secondary" size="full" @click="emits('openForm')">
        {{ props.formLabel }}
      </AppButton>
    </div>
  </div>
</template>
